import React from 'react'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'
import TabletAppointmentForm from './TabletAppointmentForm'

export default function TabletCreateAppointmentPage ({ box, onFinishFailed, onFinish, loading }) {
  return (
    <>
      <PublicSiderXS />
      <TabletAppointmentForm box={box} onFinishFailed={onFinishFailed} onFinish={onFinish} loading={loading} />
    </>
  )
}
